import { FC } from 'react'
import { ScoreGoalDto } from '../../../types'
import { AvatarData } from '../appraisal-flow/shared/appraisal-types'
import { AppraisalContextType } from '../AppraisalTypes'
import { ScoreGridEntry } from './ScoreGridEntry'

type Props = {
  reviewerAvatar: AvatarData
  employeeAvatar: AvatarData
  score: ScoreGoalDto
  type: AppraisalContextType
  focus?: boolean
  validateInputs?: boolean
  updateFn: (newScoreGoal: ScoreGoalDto) => void
}
export const ScoreGoalForm: FC<Props> = ({ score, reviewerAvatar, employeeAvatar, type, focus, validateInputs, updateFn }) => {
  const createScoreGoal = (value: number): ScoreGoalDto => {
    switch (type) {
      case AppraisalContextType.Meeting:
        return { ...score, resultEvaluation: value }
      case AppraisalContextType.Manager:
        return { ...score, reviewerEvaluation: value }
      case AppraisalContextType.Employee:
        return { ...score, employeeEvaluation: value }
    }
  }

  const update = (value: number) => {
    updateFn(createScoreGoal(value))
  }

  const isInputInvalid =
    (type === AppraisalContextType.Meeting && score.resultEvaluation === null) ||
    (type === AppraisalContextType.Employee && score.employeeEvaluation === null)

  return (
    <ScoreGridEntry
      score={score}
      type={type}
      reviewerAvatar={reviewerAvatar}
      employeeAvatar={employeeAvatar}
      focus={focus}
      onBlur={update}
      onSetScoreButtonClicked={(value) => {
        if (value !== undefined) {
          update(value)
        }
      }}
      invalid={validateInputs && isInputInvalid}
    />
  )
}
